// Router + auth gating. Mirrors apps/dashboard/src/routes/router.tsx.
// Differences:
//   • Smaller route table — P0 only ships /, /tenants…/staff as
//     placeholder pages so the navigation can be exercised end-to-end.
//   • The placeholder routes share one component (PlaceholderPage)
//     that explains the sub-phase landing it.

import { Navigate, Route, Routes } from 'react-router-dom';
import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { AppProviders } from '../lib/providers.js';
import { AppShell } from '../components/layout/app-shell.js';
import { OverviewPage } from './overview.js';
import { SignInPage } from './sign-in.js';
import { TenantsListPage } from './tenants/list.js';
import { TenantDetailPage } from './tenants/detail.js';
import { TicketsListPage } from './tickets/list.js';
import { TicketDetailPage } from './tickets/detail.js';
import { BillingPage } from './billing/page.js';
import { MoneyPage } from './money/page.js';
import { SecurityPage } from './security/page.js';
import { StripePage } from './stripe/page.js';
import { AuditPage } from './audit/page.js';
import { HealthPage } from './health/page.js';
import { StaffPage } from './staff/page.js';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route
        path="/*"
        element={
          <>
            <SignedOut>
              <Navigate to="/sign-in" replace />
            </SignedOut>
            <SignedIn>
              <AppProviders>
                <AppShell />
              </AppProviders>
            </SignedIn>
          </>
        }
      >
        <Route index element={<OverviewPage />} />
        <Route path="tenants" element={<TenantsListPage />} />
        <Route path="tenants/:id" element={<TenantDetailPage />} />
        <Route path="tickets" element={<TicketsListPage />} />
        <Route path="tickets/:id" element={<TicketDetailPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="money" element={<MoneyPage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="stripe" element={<StripePage />} />
        <Route path="audit" element={<AuditPage />} />
        <Route path="health" element={<HealthPage />} />
        <Route path="staff" element={<StaffPage />} />
      </Route>
    </Routes>
  );
}
